import { Typography, StackProps, Stack } from '@mui/material'
import React from 'react'

interface SectionHeaderProps {
  title: string
  subtitle?: string
  variant?: 'dashboard' | 'tab'
  slotProps?: { root?: StackProps }
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  variant = 'dashboard',
  slotProps,
}) => {
  return (
    <>
      {variant === 'dashboard' && (
        <Stack className="tw-mt-5" {...slotProps?.root}>
          <Typography variant="subtitle2" component="h2" mb={2}>
            {title}
          </Typography>
          {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
        </Stack>
      )}

      {variant === 'tab' && (
        <Stack className="" {...slotProps?.root}>
          <Typography variant="body1">{title}</Typography>
          {subtitle && <Typography variant="body2">{subtitle}</Typography>}
        </Stack>
      )}
    </>
  )
}

export default SectionHeader
